// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3eL1u","head":"Table_head__37x-c","col":"Table_col__3m7CH"};